import React from 'react';

interface TypeformProgressProps {
  current: number;
  total: number;
  progress: number;
  accentColor?: string;
}

export const TypeformProgress: React.FC<TypeformProgressProps> = ({
  current,
  total,
  progress,
  accentColor,
}) => {
  return (
    /* mobile-ui.6.E E1: layout inline UNIVERSAL (decisão PO smoke round 4) — barra flex-1 à
       esquerda + contador "N de M" à direita, UMA linha em todas as superfícies (desktop,
       portrait, landscape). Substitui o empilhado do portrait e o gate short: do 6.D D2.
       Contador text-xs mobile / text-sm desktop, sempre tabular-nums. */
    <div className="w-full flex items-center gap-3">
      <div className="h-1 flex-1 min-w-0 bg-neutral-800 rounded-full overflow-hidden">
        <div
          className="h-full transition-all duration-300"
          style={{
            width: `${progress}%`,
            backgroundColor: accentColor || '#3b82f6',
          }}
        />
      </div>
      <span className="shrink-0 text-xs md:text-sm text-neutral-400 tabular-nums">
        {current + 1} de {total}
      </span>
    </div>
  );
};
